import Entity from './entity';
export default class Email extends Entity<number> {
  to: Array<string>;
  subject:string;
  body:string;
}